import React from 'react';
import { Page } from '../../page/page';
import { CodeEditor } from '../../code-editor/code-editor';
import { HintModal } from '../../modal/hint-modal';

import './example-B.css';

const cardContainer = ".card-container {\n  width: 200px;\n  height: 200px;\n  perspective: 1000px;\n}";
const card = ".card {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  transform-style: preserve-3D;\n}";
const cardHover = ".card:hover {\n  transform: rotateY(180deg);\n}"
const frontAndBack = ".front, .back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backface-visibility: hidden;\n}";
const front = ".front {\n  background-color: #F25B21;\n  color: white;\n  font-size: 50px;\n}";
const back = ".back {\n  transform: rotateY(180deg);\n  background-color: #4048E7\n}";

const css =  {
  isEditable: true,
  initial: `${cardContainer}\n\n${card}\n\n${frontAndBack}\n\n${front}\n\n${back}`,
}


const iFrame = "<img src='https://media.giphy.com/media/LmNwrBhejkK9EFP504/giphy.gif' width='100%' height='100%'/>"

const html = {
  isEditable: true,
  initial: `<div class='card-container'>\n  <div class='card'>\n    <div class='front'>?</div>\n    <div class='back'>${iFrame}</div>\n  </div>\n</div>`
}

const js = {
  isEditable: false,
  initial: "",
}
  
export const ExampleB = (props) => {
  return <Page html={html} css={css} js={js}>
    <div className="example">
      <h1 className="title">Challenge 2: 3D transforms</h1>
      <div className="instructions">Using a combination of <code>transition</code> and <code>:hover</code>, write a 3D animation to flip the card over when hovered on to see what's hidden on the other side.  <br/><br/>
      </div>
      
      <div className="card-container">
        <div className="card">
          <div className="front">hover me</div>
          <div className="back">?</div>
        </div>
      </div>
      <HintModal>
        The transition property must be added to smoothly change the transform value:
        <pre>
          <div className="code">
            { `.card {`} <br/>
            { `   ...`}<br/>
            { `   transition: transform /*duration*/`}<br/>
            { `}`}
          </div>
        </pre>
        We also need to specify the rotation when we hover over the card:
        <pre>
          <div className="code">
            { `.card:hover {`}<br/>
            { `    transform: rotateY(??) `} <br/>
            { `}`}<br/>
          </div>
        </pre>
      </HintModal>
    </div>
    <CodeEditor html={html} css={css} js={js} defaultTab={'css'} />
  </Page>
}
